









































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { ProjectData } from '@/interfaces/ProjectData';
import { ProjectListItem } from '@/interfaces/ProjectListItem';

@Component({
    name: 'RecordLocationSelect',
})
export default class RecordLocationSelect extends Vue {
    @Prop({required: true}) protected folders!: ProjectListItem[];
    @Prop({required: true}) protected error!: string;
    @Prop({default: 'buyPrepaidCredit'}) protected checkoutMethod!: string;

    protected recordLocation = 'newProject';

    protected newFolder = {
        name: '',
        description: '',
    };

    protected selectedFolderName = '';

    protected get shouldRecordLocationShow() {
        if (this.checkoutMethod === 'buyPrepaidCredit' || this.checkoutMethod === 'buySubscription') {
            return false;
        }
        return true;
    }

    protected querySearch(queryString: string, cb: (results: ProjectListItem[]) => void) {
        const folders = this.folders;
        const results = queryString ? folders.filter(this.createFilter(queryString)) : folders;
        // call callback function to return suggestions
        cb(results);
    }

    protected createFilter(queryString: string) {
        return (folder: ProjectListItem) => {
            return (folder.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
    }

    protected handleSelect(item: ProjectListItem) {
        this.selectedFolderName = item.name;
        this.$emit('existingFolderChange', {
            name: item.name,
            type: 'existingProject',
        });
    }

    protected onNewFolderChange() {
        this.$emit('newFolderChange', {
            name: this.newFolder.name,
            description: this.newFolder.description,
            type: 'newProject',
        });
    }

    // @Watch('folders', {immediate: true, deep: true})
    // protected onFoldersChange() {
    //     this.folders = this.$store.getters['projects/myProjectsList'];
    // }
}
